import React, { useEffect, useState } from 'react'
import { Box, Stack, Text } from '@mantine/core'

import { CalendarCourtReporterEvent } from '@/apiClient'
import {
  CourtReporterOwnStatusFilter,
  SearchFilter,
  TimezoneFilter,
} from '@/components/Calendar/FilterControls'
import { useQueryParams } from '@/hooks/useQueryParams'

export type Filters = {
  court_reporter_status_in: CalendarCourtReporterEvent['court_reporter_status'][]
  search?: string
  timezone_in?: string[]
}

// Filters in query params have priority over default initial params
export const useInitialFilters = (initialFilters: Filters): Filters => {
  const queryParams = useQueryParams()
  const queryFilters: Partial<Filters> = {}
  if (queryParams.getAll('court_reporter_status_in').length > 0) {
    queryFilters['court_reporter_status_in'] = queryParams.getAll(
      'court_reporter_status_in',
    ) as Filters['court_reporter_status_in']
  }
  if (queryParams.get('search')) {
    queryFilters['search'] = queryParams.get('search') || undefined
  }

  return {
    ...initialFilters,
    ...queryFilters,
  }
}

export const FilterControls: React.FC<{
  values: Filters
  onChange: (filters: Filters) => void
}> = ({ values: initialFilters, onChange }) => {
  const [filters, setFilters] = useState<Filters>(initialFilters)

  useEffect(() => {
    onChange(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <Box ml="xl" mr="xl" mt="xs">
      <Stack>
        <Text weight="bold">Visible events</Text>
        <Stack spacing="sm">
          <CourtReporterOwnStatusFilter
            values={filters.court_reporter_status_in}
            onChange={statuses =>
              setFilters(filters => ({
                ...filters,
                court_reporter_status_in: statuses,
              }))
            }
          />
        </Stack>
        <Text weight="bold" mt="sm">
          Filters
        </Text>
        <Stack spacing="md">
          <SearchFilter
            value={filters.search ?? ''}
            onChange={search => setFilters(filters => ({ ...filters, search }))}
          />
          <TimezoneFilter
            value={filters.timezone_in}
            onChange={timezone_in =>
              setFilters(filters => ({ ...filters, timezone_in }))
            }
          />
        </Stack>
      </Stack>
    </Box>
  )
}
